import { Injectable, inject } from '@angular/core';
import { ActionCenterService } from '@app/core/services/action-center.service';
import { IconSnackBarService } from '@app/core/services/icon-snack-bar.service';
import { aiClassificationJob } from '@app/pages/cmms/graphql/file.queries';
import { IAiSuggestionJob } from '@app/shared/action-center/interfaces';
import { Apollo } from 'apollo-angular';
import { BehaviorSubject, firstValueFrom, map, timeout } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class FileAiSuggestionService {
	private readonly apollo = inject(Apollo);
	private readonly actionCenterService = inject(ActionCenterService);
	private readonly notify = inject(IconSnackBarService);
	suggestionStarted$ = new BehaviorSubject<{
		job: IAiSuggestionJob;
	}>({
		job: {
			pk: null,
			processed: 0,
			status: undefined,
			total: 0,
		},
	});

	suggestionAnalysis$ = new BehaviorSubject<IAiSuggestionJob>({
		pk: null,
		processed: 0,
		status: undefined,
		total: 0,
	});

	ongoingSuggestionAnalyze$ = new BehaviorSubject<boolean>(false);
	private readonly ongoingSubscriptionStatuses = ['CREATED', 'IN_PROGRESS'];

	subscribeToJob = async (pk: string, counter = 0) => {
		await firstValueFrom(
			this.apollo
				.query<{
					aiClassificationJob: IAiSuggestionJob;
				}>({
					query: aiClassificationJob,
					fetchPolicy: 'network-only',
					variables: { pk },
				})
				.pipe(
					timeout(10000),
					map(res => {
						this.suggestionAnalysis$.next(res.data.aiClassificationJob);
						this.ongoingSuggestionAnalyze$.next(true);
						if (
							this.ongoingSubscriptionStatuses.includes(
								res.data.aiClassificationJob.status
							) &&
							counter < 10
						) {
							counter++;
							return setTimeout(() => this.subscribeToJob(pk, counter), 5000);
						}

						this.actionCenterService.actionDone$.next();
						let message = 'AI Analyzing succesfully completed, No suggesstions found';
						if (res?.data?.aiClassificationJob.processed > 0) {
							message = 'AI Analyzing succesfully completed';
						}
						this.notify.success(message);
						this.ongoingSuggestionAnalyze$.next(false);
						return res?.data?.aiClassificationJob;
					})
				)
		);
	};
}
